export default __webpack_public_path__ + "static/media/saveFavIcon2.29a77410.svg";